﻿import { httpDelete, httpGet, httpPut } from '@pressreader/services';

import type { ArticleCollectionsUpsertDto, WithCollectionsDto } from '../types';

import { articlesApiEndpointBaseUrl, disableRetryParam, jsonBodyParam } from './constants';

function getArticleCollectionsUrlPath(articleId: string): string {
    return `${articleId}/collections`;
}

async function upsertArticleCollectionsData(articleId: string, data: ArticleCollectionsUpsertDto): Promise<void> {
    return httpPut(articlesApiEndpointBaseUrl, getArticleCollectionsUrlPath(articleId), data, jsonBodyParam);
}

function getArticleCollectionsData(articleId: string) {
    return httpGet<WithCollectionsDto>(articlesApiEndpointBaseUrl, getArticleCollectionsUrlPath(articleId));
}

function removeArticleFromCollections(articleId: string): Promise<void> {
    return httpDelete(articlesApiEndpointBaseUrl, getArticleCollectionsUrlPath(articleId), disableRetryParam);
}

export { getArticleCollectionsData, removeArticleFromCollections, upsertArticleCollectionsData };
